module.exports = __webpack_public_path__ + "img/finanziario_pressed.9c2bb96a.png";